// ```recipe blocks, shown as Cooking for Engineers style cards
import {
  findRecipes,
  type Recipe,
} from '@/app/recipe/recipe';
import { type BlockKind } from './blocks';
import { RecipeCard } from './RecipeCard';

export const recipeBlocks: BlockKind<Recipe> = {
  name: 'recipe',
  find: findRecipes,
  draw: (recipe, on) => (
    <RecipeCard steps={recipe.steps} onEditText={on.editText} />
  ),
};

export const newRecipe = [
  '```recipe',
  'bake 30 min',
  '  mix',
  '    first ingredient',
  '    second ingredient',
  '  third ingredient',
  '```',
  '',
].join('\n');
